import BaseService from "../BaseService";

class StaticContentService extends BaseService {
  getStaticContent(key: string, language: string) {
    return this.fetch<{ content: string }>(`static/${key}/${language}`);
  }

  updateStaticContent(
    key: string,
    language: string,
    data: { content: string }
  ) {
    return this.put<void, { content: string }>(
      `static/${key}/${language}`,
      data
    );
  }
}

export default StaticContentService;
